import createTariff from './actions/createTariff';
import getTariff from './actions/getTariff';
import tariffsList from './actions/tariffsList';
import updateTariff from './actions/updateTariff';
import fetchVpnTariffs from './actions/fetchVpnTariffs';
import getTariffs from './getters/getTariffs';
import uploadTariffs from './mutations/uploadTariffs';


const actions = {
    createTariff,
    updateTariff,
    tariffsList,
    getTariff,
    fetchVpnTariffs
};

const mutations = {
    uploadTariffs
};

const getters = {
    getTariffs
};

export default { actions, mutations, getters };
